module.exports = __webpack_public_path__ + "static/media/Phoenix_jacket.163c273e.jpg";